<template>
  <div class="wrapper flex-row align-center justify-end full-parent">
    <div class="info-block flex-column align-start justify-start">
      <slideInfo
        title="不止是月嫂#专业团队竭诚#为您服务"
        desc="个性化服务/异常处理/专业咨询/过程监控"
        buttonText="找月嫂"
        :width="11.25"
      />
    </div>
    <div class="team-block flex-row">
      <div v-for="(item, index) of teamList" :key="index" class="team-item">
        <img
          draggable="false"
          class="bg full-parent skeleton swiper-lazy"
          :data-src="item.img"
        />
        <div class="swiper-lazy-preloader" />
        <div class="team-info-block">
          <div class="info-wrapper">
            <div class="title">{{ item.title }}</div>
            <div class="desc">{{ item.desc }}</div>
            <div class="divider" />
          </div>
          <div class="info-bg full-parent" />
        </div>
      </div>
    </div>

    <decorate :list="decorateList" />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import slideInfo from "../slide-info/slide-info.vue";

export default defineComponent({
  components: { slideInfo },

  data() {
    return {
      teamList: [
        { title: '星级月嫂', desc: '提供居家护理服务，包括宝宝护理、妈妈护理、月子餐制作等', img: 'https://mm2015.mamalaile.com.cn/ac1c1a7d9418c22100ce1a0f1fcf0a16.png' },
        { title: '服务管家', desc: '妈妈来了会给每一位用户匹配一个专属的服务管家全程跟踪您的服务', img: 'https://mm2015.mamalaile.com.cn/2541964a4c086da501e16b1c2d4329ee.png' },
        { title: '月子顾问', desc: '跟进您整个孕期，月子期身体异常、生产准备、产后康复等相关问题，减少您的孕期焦虑', img: 'https://mm2015.mamalaile.com.cn/9d7750059ad26fc7533c38479a7c9d7a.png' },
        { title: '护理老师', desc: '全程跟进宝妈、宝宝的医护问题，解决宝妈担心的母乳喂养、产后康复等问题', img: 'https://mm2015.mamalaile.com.cn/01e944ff5d16a4e6ca202a50d8077679.png' },
      ],
      decorateList: [
        { position: 'bottom-left', url: require('/src/assets/images/home_pic5_bg@2x.png'), width: 28.07 },
      ]
    };
  }
});
</script>

<style lang="less" scoped>
.wrapper {
  position: relative;

  .info-block {
    margin-right: 6.2vw;
  }

  .team-block {
    height: 100%;
    flex-shrink: 0;
    position: relative;

    .team-item {
      width: 18.49vw;
      position: relative;
      flex: 1;
      overflow: hidden;
      margin-right: 0.78vw;

      &:last-child {
        margin-right: 0;
      }

      .bg {
        object-fit: cover;
      }

      .team-info-block {
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 4.16vw + 2.08vw;
        padding: 1.56vw 1.2vw 2.08vw;
        color: white;
        transform: translateY(100%);
        transition: transform 0.4s ease, bottom 0.4s ease;

        .info-bg {
          position: absolute;
          left: 0;
          top: 0;
          z-index: 0;
          opacity: 0;
          background: @color-primary
            url("~@/assets/images/home_pic5_select@2x.png") no-repeat 100% 0;
          background-size: 6.56vw auto;
          transition: opacity 0.3s ease;

          img {
            width: 6.56vw;
            height: auto;
            position: absolute;
            z-index: 1;
            top: 0;
            right: 0;
          }
        }

        .info-wrapper {
          position: relative;
          z-index: 2;

          .title {
            position: relative;
            font-size: 1.56vw;
            line-height: 2.19vw;
            margin-bottom: 1.56vw;
            font-family: @font-ab;
            left: 50%;
            transform: translateX(-50% + 32.18vw);
            transition: transform 0.5s ease, left 0.5s ease;
          }

          .desc {
            font-size: 14px;
            line-height: 24px;
            margin-bottom: 35px;
            opacity: 0;
            transition: opacity 0.3s ease;
          }

          .divider {
            width: 23px;
            height: 2px;
            border-radius: 2px;
            background-color: white;
            opacity: 0;
            transition: opacity 0.3s ease;
          }
        }
      }

      &:hover {
        .team-info-block {
          bottom: 0;
          transform: translateY(0);

          .info-bg,
          .desc,
          .divider {
            opacity: 1;
          }

          .title {
            left: 0;
            transform: translateX(0);
          }
        }
      }
    }
  }
}
</style>